// NEXRAD WSR-88D site lookup — the client side of the render service's site table. The
// viewer uses it for the "nearest site" default and the search / pick-any-site control;
// the on-demand /render endpoint accepts any of these ids. The table itself is
// AUTO-GENERATED from services/radar-render/sites.py (see sites.data.ts) so the two never
// drift. Pure logic — RN-portable.

import { SITE_TABLE } from './sites.data'

export interface RadarSite {
  id: string
  name: string
  lat: number
  lon: number
}

export const SITES: RadarSite[] = SITE_TABLE

const D2R = Math.PI / 180

/** Nearest rendered site to a point (equirectangular distance — fine at CONUS scale). */
export function nearestSite(lat: number, lon: number, sites: RadarSite[] = SITES): RadarSite {
  let best = sites[0]
  let bestD = Infinity
  const latR = lat * D2R
  for (const s of sites) {
    const dx = (s.lon - lon) * Math.cos(latR)
    const dy = s.lat - lat
    const d = dx * dx + dy * dy
    if (d < bestD) {
      bestD = d
      best = s
    }
  }
  return best
}

/** Search sites by id or city name; id-prefix matches rank first. */
export function searchSites(query: string, limit = 12): RadarSite[] {
  const q = query.trim().toLowerCase()
  if (!q) return []
  const hits = SITES.filter((s) => s.id.toLowerCase().includes(q) || s.name.toLowerCase().includes(q))
  hits.sort((a, b) => {
    const ap = a.id.toLowerCase().startsWith(q) ? 0 : 1
    const bp = b.id.toLowerCase().startsWith(q) ? 0 : 1
    return ap - bp || a.id.localeCompare(b.id)
  })
  return hits.slice(0, limit)
}

export const siteById = (id: string): RadarSite | undefined => SITES.find((s) => s.id === id.toUpperCase())
